import { EnumSchema } from '../metadata-schema';

export const ExamenstatusMetPrognose: EnumSchema = {
	"type": "string",
	"title": "ExamenstatusMetPrognose",
	"enum": [
		"Geslaagd",
		"Geslaagd (prognose)",
		"Afgewezen",
		"Afgewezen (prognose)",
		"Voortijdig teruggetrokken",
		"Overig",
		"Tijdens examen teruggetrokken",
		"Voorlaatste jaar",
		"Gespreid examen",
		"Aangemeld"
	]
};
